import { useContext } from 'react';

import { ApiContext } from './api.context';
import type { AdminApiEndpoints } from './api.endpoints';

export function useApi(): AdminApiEndpoints {
    const apiCtx = useContext(ApiContext);

    if (!apiCtx.api) {
        throw new Error('No API provided');
    }

    return apiCtx.api;
}
